<ng-container *ngIf="control">
<!-- label [attr.for]="name" -->
<label *ngIf="label && type !== 'hidden' && !isCheckLabelAlign" [for]="id" class="label"
    [ngClass]="{'green': isGreenLabel, 'disabled': disabled}">{{label}}<span *ngIf="label && required">*</span></label>
<!-- input-container [class.invalid]="control.touched && control.invalid" -->
<input #input *ngIf="type === 'hidden'" [type]="type" [placeholder]="placeholder" [attr.name]="name" [attr.id]="id"
    [formControl]="control">

<!-- Form input Field Text-->
<div *ngIf="(!selectValue || selectValue.length === 0) && type !== 'hidden' && type !== 'date' && type !== 'ngSelect' && type !== 'textarea' && type !== 'checkbox' && type !== 'time' && type !== 'fake-number' && type !== 'fake-int-number' && type !== 'ref-search-input' && type !== 'autocomplete'"
    class="input-container" [formGroup]="formGroup" [ngClass]="{'sizeup': (control.errors && control.touched), 'disabled': disabled}">
    <div class="input">
        <input #input [value]="control.value" [type]="type" [placeholder]="placeholder" [attr.name]="name"
            [attr.id]="id" [formControl]="control" (ngModelChange)="changed(control)" [min]="minNumber"
            [max]="maxNumber" (focus)="focusFunction()" (blur)="onBlur()" [readonly]="disabled">
        <div class="error-container" [ngClass]="{'no-height': (!control.errors || !control.touched)}">
            {{errorMessage}}
        </div>
    </div>
    <div *ngIf="type === 'password'" class="icon-container" (click)="togglePasswordVisibility()">
        <div *ngIf="!noeye" class="icon eye">
        </div>
        <div *ngIf="noeye" class="icon no-eye">
        </div>
    </div>
    <div *ngIf="deletable && control.value !== ''" class="icon-container" (click)="deleteInputContent()">
        <div class="icon delete-input">
        </div>
    </div>
</div>
<!-- Form input Recherche référentiel-->
<div *ngIf="(!selectValue || selectValue.length === 0) && type === 'ref-search-input'"
    class="input-container">
    <div class="input">
        <input class="intput-recherche-referentiel" readonly #input [value]="control.value && control.value.id && control.value.libelle ? control.value.libelle : control.value" type="text" [placeholder]="placeholder" [attr.name]="name"
            [attr.id]="id" [min]="minNumber"
            [max]="maxNumber" (focus)="focusFunction()" (click)="searchRef($event)">
        <div class="error-container" [ngClass]="{'no-height': (!control.errors || !control.touched)}">
            {{errorMessage}}
        </div>
    </div>
</div>
<!-- Form input Recherche référentiel-->
<div *ngIf="type === 'autocomplete'" class="ngselect-container"
    [formGroup]="formGroup" [ngClass]="{'sizeup': (control.errors && control.touched)}">
    <ng-select dropdownPosition="bottom" [clearable]="isClearableSelect" [items]="selectValue && selectValue.length > 0 ? selectValue : []"
        closeOnSelect="true" bindLabel="libelle" bindValue="id" [attr.name]="name" [loading]="searchFunctionLoading" loadingText="Recherche en cours" notFoundText="Aucun élément trouvé" typeToSearchText="Saisissez votre recherche"
        [attr.id]="id" [formControl]="control" class="input" (ngModelChange)="changed(control)" [formControlName]="id"
        [readonly]="disabled" [appendTo]="isParentModal ? 'body' : undefined" [typeahead]="autocompleteSearchInput$" [minTermLength]="autocompleteSearchMinTermLength">
    </ng-select>
    <div class="error-container" [ngClass]="{'no-height': (!control.errors || !control.touched)}">
        {{errorMessage}}
    </div>
</div>
<!-- Form input Field Check-->
<div *ngIf="(!selectValue || selectValue.length === 0) && type === 'checkbox'" class="check-container"
    [formGroup]="formGroup" [ngClass]="{'sizeup': (control.errors && control.touched), 'disabled': disabled}">
    <div class="input">
        <label *ngIf="label && type !== 'hidden' && isCheckLabelAlign" [ngClass]="{'green': isGreenLabel}">
            <input #input [value]="control.value" [type]="type" [placeholder]="placeholder"
                [attr.name]="name" [attr.id]="id" [formControl]="control" (ngModelChange)="changed(control)"
                (change)="changeCheck($event)" [readonly]="disabled">
            <span class="checkMark"></span>
            {{label}}<span *ngIf="label && required">*</span>
        </label>
        <div *ngIf="!isCheckLabelAlign" (mousedown)="changedUnalignedCheckbox(control)">
            <input #input [value]="control.value" [type]="type" [placeholder]="placeholder"
                [attr.name]="name" [attr.id]="id" [formControl]="control" (ngModelChange)="changed(control)"
                (change)="changeCheck($event)" [readonly]="disabled">
            <span class="checkMark"></span>
        </div>
        <div class="error-container" [ngClass]="{'no-height': (!control.errors || !control.touched)}">
            {{errorMessage}}
        </div>
    </div>
</div>
<!-- Form input Field Textarea-->
<div *ngIf="(!selectValue || selectValue.length === 0) && type === 'textarea'" class="textarea-container"
    [formGroup]="formGroup">
    <textarea #input [value]="control.value" [placeholder]="placeholder" [attr.name]="name" [attr.id]="id"
        [formControl]="control" (ngModelChange)="changed(control)" [rows]="nbRows" (focus)="focusFunction()"
        [readonly]="disabled" class="not-resizable" (blur)="onBlur()" [ngClass]="{ 'not-resizable': !textareaResizable, 'disabled': disabled }"></textarea>
    <div class="error-container" [ngClass]="{'no-height': (!control.errors || !control.touched)}">
        {{errorMessage}}
    </div>
</div>
<!-- Form input Field Date-->
<div *ngIf="(!selectValue || selectValue.length === 0) && type === 'date'" class="date-container"
    [formGroup]="formGroup" [ngClass]="{'sizeup': (control.errors && control.touched)}">
    <div class="mat-date-field">
        <input #input [formControl]="control" [placeholder]="placeholder" (ngModelChange)="changed(control)" matInput
            [matDatepicker]="picker" [min]="minDate" [max]="maxDate" rInputMask="99/99/9999" (focus)="focusFunction()"
            [readonly]="disabled" [ngClass]="{'disabled': disabled}">
        <mat-datepicker-toggle matSuffix [for]="picker" class="cal-button" [disabled]="disabled"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
    </div>

    <div class="error-container" [ngClass]="{'no-height': (!control.errors || !control.touched)}">
        {{errorMessage}}
    </div>
</div>
<!-- Form input Field ng-select-->
<div *ngIf="selectValue && (checkSelectValueLength || selectValue.length !== 0) && type === 'ngSelect'" class="ngselect-container"
    [formGroup]="formGroup" [ngClass]="{'sizeup': (control.errors && control.touched)}">
    <ng-select dropdownPosition="bottom" [clearable]="isClearableSelect" [items]="selectValue"
        [multiple]="isMultiSelect" [closeOnSelect]="closeOnSelect" bindLabel="libelle" bindValue="id" [attr.name]="name"
        [attr.id]="id" [formControl]="control" class="input" (ngModelChange)="changed(control)" [formControlName]="id"
        [readonly]="disabled" [appendTo]="isParentModal ? 'body' : undefined" [placeholder]="placeholder">
    </ng-select>
    <div class="error-container" [ngClass]="{'no-height': (!control.errors || !control.touched)}">
        {{errorMessage}}
    </div>
</div>
<!-- Form input Select -->
<div *ngIf="selectValue && selectValue.length !== 0 && type !== 'ngSelect' && type !== 'colorSelect' && type !== 'autocomplete'"
    class="input-container clickable" [formGroup]="formGroup"
    [ngClass]="{'sizeup': (control.errors && control.touched), 'disabled': disabled}">
    <div class="input">
        <div class="value-and-error-container">
            <input #input class="disabled" [type]="type" [placeholder]="placeholder" [attr.name]="name" [attr.id]="id"
                [formControl]="control" (ngModelChange)="changed(control)" [readonly]="disabled">
            <div class="error-container" [ngClass]="{'no-height': (!control.errors || !control.touched)}">
                {{ errorMessage }}
            </div>
        </div>
        <div #listcontainer class="select-list-container"
            [ngClass]="{'dropdown': selectOpen, 'error-message-top': control.errors && control.touched}">
            <div class="select-list-value" *ngFor="let value of selectValue" (click)="setValue(value)"
                [ngClass]="{'selected': control.value === value}">{{value}}</div>
        </div>
    </div>
    <div class="icon-container icon-select">
        <div class="icon chevron" [ngClass]="{'upsidedown': selectOpen}">
        </div>
    </div>
</div>
<!-- Form input colorSelect -->
<div *ngIf="selectValue && selectValue.length !== 0 && type === 'colorSelect'" class="input-container clickable"
    [formGroup]="formGroup" [ngClass]="{'sizeup': (control.errors && control.touched), 'disabled': disabled}">
    <div class="input">
        <div class="value-and-error-container">
            <input #input class="disabled" [type]="type" [placeholder]="placeholder" [attr.name]="name" [attr.id]="id"
                [formControl]="control" (ngModelChange)="changed(control)" [readonly]="disabled">
            <div class="error-container" [ngClass]="{'no-height': (!control.errors || !control.touched)}">
                {{ errorMessage }}
            </div>
        </div>
        <div #listcontainer class="select-list-container"
            [ngClass]="{'dropdown': selectOpen, 'error-message-top': control.errors && control.touched}">
            <div class="select-list-value empty" (click)="setValue()">Vider</div>
            <div class="select-list-value" *ngFor="let value of selectValue" (click)="setValue(value)"
                [ngStyle]="{'background-color': hexToRgba('#'+value.libelle)}">{{ ' ' }}</div>
        </div>
    </div>
    <div class="icon-container icon-select">
        <div class="icon chevron" [ngClass]="{'upsidedown': selectOpen}">
        </div>
    </div>
</div>
<!-- Form input time-->
<div *ngIf="(!selectValue || selectValue.length === 0) && type === 'time'" class="time-container"
    [formGroup]="formGroup" [ngClass]="{'sizeup': (control.errors && control.touched)}">
    <input #input [formControl]="control" [placeholder]="placeholder" (ngModelChange)="changed(control)" type="time"
        [min]="minTime" [max]="maxTime" [readonly]="disabled">

    <div class="error-container" [ngClass]="{'no-height': (!control.errors || !control.touched)}">
        {{errorMessage}}
    </div>
</div>

<!-- Form input fake number-->
<div *ngIf="(!selectValue || selectValue.length === 0) && type === 'fake-number'" class="input-container"
    [formGroup]="formGroup" [ngClass]="{'sizeup': (control.errors && control.touched), 'disabled': disabled}">
    <input #input [formControl]="control" [placeholder]="placeholder" type="text" [readonly]="disabled"
        (keyup)="onKeyPressFakeNumber(control, $event)" (focusout)="onfocusoutFakeNumber(control, $event)">

    <div class="error-container" [ngClass]="{'no-height': (!control.errors || !control.touched)}">
        {{errorMessage}}
    </div>
</div>

<!-- Form input fake int number-->
<div *ngIf="(!selectValue || selectValue.length === 0) && type === 'fake-int-number'" class="input-container"
    [formGroup]="formGroup" [ngClass]="{'sizeup': (control.errors && control.touched), 'disabled': disabled}">
    <input #input [formControl]="control" [placeholder]="placeholder" type="text" [readonly]="disabled"
        (keyup)="onKeyPressFakeIntNumber(control, $event)" (focusout)="onfocusoutFakeNumber(control, $event)">

    <div class="error-container" [ngClass]="{'no-height': (!control.errors || !control.touched)}">
        {{errorMessage}}
    </div>
</div>
</ng-container>
